<script setup lang="ts">
import type { ILabel } from '~/interfaces/crossSell/ICrossSell';

const props = defineProps<{
  label: ILabel,
  absolute: boolean
}>()

const {
  label,
  absolute
} = toRefs(props);

const customLabels = ref([
  {
    hasIcon: true,
    label:'is-new',
    eclat: 'new',
    trad: 'www.product.is_new.v2',
    size: 15,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'deal',
    eclat: 'deal',
    trad: 'www.product.deal',
    size: 17,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'eco',
    eclat: 'eco',
    trad: 'www.product.eco',
    size: 15,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'vae',
    eclat: 'vae',
    trad: 'www.product.vae',
    size: 12,
    fill: 'cicon--f-dark'
  },
  {
    hasIcon: true,
    label:'express-delivery',
    eclat: 'express',
    trad: 'www.product.express',
    size: 20,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label: 'sale',
    eclat: 'promo',
    trad: 'www.product.sale',
    size: 12,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'black-friday',
    eclat: 'promo',
    trad: 'www.product.black-friday',
    size: 12,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'black-week',
    eclat: 'promo',
    trad: 'www.product.black-week',
    size: 12,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'french-days',
    eclat: 'promo',
    trad: 'www.product.french-days',
    size: 12,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'colidays',
    eclat: 'promo',
    trad: 'www.product.colidays',
    size: 12,
    fill: 'cicon--f-light'
  },
  {
    hasIcon: true,
    label:'cyber-monday',
    eclat: 'promo',
    trad: 'www.product.cyber-monday',
    size: 12,
    fill: 'cicon--f-zlight'
  },
  {
    hasIcon: false,
    label:'merchant-voucher',
    eclat: '',
    trad: null,
    size: '',
    fill: ''
  }
])

const currentLabel = ref(customLabels.value.filter((customLabel) => customLabel.label === label.value.id)[0]);
</script>

<template>
  <div :class="absolute ? 'cproduct__label' : ''">
    <a
       :href="label.link !== '' ? label.link : 'javascript:void(0)'"
       :style="label.link !== '' ? '' : 'cursor: initial'"
       :class="`size--${currentLabel.size} weight--intermedium label--eclat label--${label.id}`"
       :target="label.link !== '' ? '_blank' : ''"
       data-tclz-selector="eclat"
       :data-tclz-label="label.link"
       data-tclz-category="product"
       :data-tclz-action="`click on eclat ${label.id}`">
      <svg
            :class="`cicon--${
            //@ts-ignore
            currentLabel.size} cicon ${currentLabel.fill}`">
        <use
              :xlink:href="`#eclat-${//@ts-ignore
              currentLabel.eclat}`"/>
      </svg>
      {{ //@ts-ignore
      $t(currentLabel.trad) ?? label.name }}
    </a>
  </div>
</template>
